export { default as Form } from 'inpc/components/form/InpcForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/form/index.js